module.exports = __webpack_public_path__ + "static/media/notsearch.f9ad60c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/notsearch.png
// module id = 4788
// module chunks = 0